import { QueryFunction, useMutation, useQuery } from "@tanstack/react-query";

const useService = (label: string, fnActions: QueryFunction) => {
    const serviceQuery = useQuery(
        [label],
        fnActions,
    );
    return serviceQuery;
}

const useSaveService = (fnActions: (e: any) => Promise<any>) => {
    const saveQuery = useMutation(fnActions);
    return saveQuery;
}

export { useService, useSaveService }